import React from "react";

const MinorSoloTreatmentQuestion = ({ onSubmit, onNext, initialValue }) => {
    const [val, setVal] = React.useState(
        typeof initialValue === "boolean" ? initialValue : null
    );

    const pick = (b, event) => {
        // Blur the button after click to prevent focus from persisting and looking like selection
        if (event && event.currentTarget) {
            event.currentTarget.blur();
        }
        setVal(b);
        onSubmit(b);
        onNext();
    };

    return (
        <form onSubmit={(e) => e.preventDefault()} className="input-form">
            <div className="treatment-options" style={{ justifyContent: "center" }}>
                <button
                    type="button"
                    className={`treatment-button ${val === true ? "treatment-button-selected" : ""}`}
                    onClick={(e) => pick(true, e)}
                >
                    Yes, I consent
                </button>
                <button
                    type="button"
                    className={`treatment-button ${val === false ? "treatment-button-selected" : ""}`}
                    onClick={(e) => pick(false, e)}
                >
                    No, I do not consent
                </button>
            </div>
        </form>
    );
};

export default MinorSoloTreatmentQuestion;
